import { ShippingRestrictionResponseDto } from '@tiendanube/common';
import {
  DeliveryZonesScope,
  ProductRestrictionType,
  RestrictionTagType,
  ShippingRestrictionScope,
  ValueRestrictionType,
  WeightRestrictionType,
} from '@tiendanube/common/src/enums';

interface TagLabelParams {
  restriction: ShippingRestrictionResponseDto;
  tagType: RestrictionTagType;
}

export function getRestrictionTagLabel({
  restriction,
  tagType,
}: TagLabelParams): string {
  switch (tagType) {
    case RestrictionTagType.LOCATION:
      if (
        restriction.distributionCenterScope ===
        ShippingRestrictionScope.SPECIFIC
      ) {
        return 'tags.location';
      }
      break;

    case RestrictionTagType.GEOGRAPHY:
      if (
        restriction.deliveryZonesScope === DeliveryZonesScope.GEOGRAPHICAL_ZONE
      ) {
        return 'tags.geography';
      }
      if (
        restriction.deliveryZonesScope === DeliveryZonesScope.DISTANCE_IN_KM
      ) {
        return 'tags.distance';
      }
      break;

    case RestrictionTagType.CATEGORY:
      if (
        restriction.productRestrictionType === ProductRestrictionType.CATEGORIES
      ) {
        return 'tags.category';
      }
      break;

    case RestrictionTagType.PRODUCT:
      if (
        restriction.productRestrictionType === ProductRestrictionType.PRODUCTS
      ) {
        return 'tags.product';
      }
      break;

    case RestrictionTagType.WEIGHT:
      if (
        restriction.weightRestrictionType === WeightRestrictionType.WEIGHT_RANGE
      ) {
        return 'tags.weight';
      }
      break;

    case RestrictionTagType.VALUE:
      if (
        restriction.valueRestrictionType === ValueRestrictionType.VALUE_RANGE
      ) {
        return 'tags.value';
      }
      break;

    default:
      return '';
  }

  return '';
}
